<div class="wrap" [ngClass]="style.toLowerCase()">
  <div class="icon">
    <app-svg-icon name="info" [color]="styleColorsMap[style]"></app-svg-icon>
  </div>
  <div class="text">{{ text }}</div>
</div>
